import React from 'react'
import { OverlayTrigger, Tooltip, Table} from 'react-bootstrap'
import { parseFloatCurrency } from '../../utils/formatting/floatnumberparsing'
import { RenderImage } from '../images/ImageView'
import { DescriptionTooltipView } from '../_reusedcomponents/DescriptionTooltipView'

/**
 * 
 * @param {any} children passed props as header of the view
 * @param {any} openModal opens a mask for articleType editing
 * @param {boolean} filterable indicates if filter menu is visible
 * @param {any} filteredArticleTypes filtered elements to be displayed
 * @param {any} GenderSelect component for selection/filtering
 * @param {any} SizeCategorySelect component for selection/filtering
 */
const ArticleTypeView = ({ children, openModal, filterable, filteredArticleTypes, handleSortArticleTypes, GenderSelect, SizeCategorySelect }) => {
    return (
        <div lang="de">

            {children}

            <div className="tablet-transactions-scroll">
                <Table className='articletype-table table-striped' aria-labelledby="tabelLabel" size="sm">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Ansicht</th>
                            <th className="mainColumn">{window.i18n('articleNumberDesigner')}
                                <a href="" className="sort-link" onClick={(e) => handleSortArticleTypes(e, 'ArticleNumberDesigner')}>&#8593; &#8595;</a></th>
                            <th className="mainColumn">{window.i18n('articleNumberFaex')}
                                <a href="" className="sort-link" onClick={(e) => handleSortArticleTypes(e, 'ArticleIdFaex')}>&#8593; &#8595;</a></th>
                            <th className="mainColumn">{window.i18n('name')}
                                <a href="" className="sort-link" onClick={(e) => handleSortArticleTypes(e, 'Name')}>&#8593; &#8595;</a></th>
                            <th className="mainColumn">{window.i18n('colour')}
                                <a href="" className="sort-link" onClick={(e) => handleSortArticleTypes(e, 'ColourDescription')}>&#8593; &#8595;</a></th>
                            <th className="mainColumn">{window.i18n('gender')}
                                <a href="" className="sort-link" onClick={(e) => handleSortArticleTypes(e, 'Sexes')}>&#8593; &#8595;</a></th>
                            <th className="mainColumn">{window.i18n('sizeCategory')}
                                <a href="" className="sort-link" onClick={(e) => handleSortArticleTypes(e, 'SizeAttribute')}>&#8593; &#8595;</a></th>
                            <th className="mainColumn">{window.i18n('description')}
                                <a href="" className="sort-link" onClick={(e) => handleSortArticleTypes(e, 'DescriptionDesigner')}>&#8593; &#8595;</a></th>
                            <th className="mainColumn">{window.i18n('salePrice')}
                                <a href="" className="sort-link" onClick={(e) => handleSortArticleTypes(e, 'SalePrice')}>&#8593; &#8595;</a></th>
                        </tr>
                    </thead>
                    {filterable ? <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>{GenderSelect}</th>
                            <th>{SizeCategorySelect}</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead> : null}
                    <tbody>
                        {filteredArticleTypes.map(articleType =>
                            <tr>
                                <td>
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip> {window.i18n('updateArticleType')} </Tooltip>}>
                                        <a className="edit-button" onClick={openModal(articleType)}>&#9998;</a>
                                    </OverlayTrigger>
                                </td>
                                <td>{RenderImage(articleType.Image)}</td>
                                <td className="mainColumn">{articleType.ArticleNumberDesigner}</td>
                                <td className="mainColumn">{articleType.ArticleIdFaex}</td>
                                <td className="mainColumn">{articleType.Name}</td>
                                <td className="mainColumn">{articleType.ColourDescription !== null ? articleType.ColourDescription.ColourName : ""}</td>
                                <td className="mainColumn">{articleType.Sexes}</td>
                                <td className="mainColumn">{articleType.SizeAttribute.SizeCategory}</td>
                                <OverlayTrigger trigger="hover" placement="top" overlay={DescriptionTooltipView(articleType.DescriptionDesigner)}>
                                    <td className="mainColumn">{articleType.DescriptionDesigner}</td>
                                </OverlayTrigger>
                                <td className="numberColumn">{parseFloatCurrency(articleType.SalePrice)}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export { ArticleTypeView }